import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { TargetSelector, getCompositeSettingSelector, makeTextStyleSelector } from "@client/selectors";
import { type AppState, type EntityRef, type WithId, type WithParentId } from "@client/types";
import { connect } from "react-redux";
import { chooseEvent } from "./actions";
import Component, { type EventItemActionProps, type EventItemMapProps } from "./component";
import { makeImageStyleSelector } from "./selectors";

export type EventItemContainerProps = Omit<RootContainerProps, "id"> & WithParentId & WithId<string>;

const makeMapStateToProps = () => {
  const imageStyleSelector = makeImageStyleSelector();

  const nameStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "name");
  const locationStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "location");
  const dateStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "date");

  const overlaySelector = getCompositeSettingSelector<{ color: string }>(TargetSelector.Entity, "overlay");

  return (state: AppState, props: EventItemContainerProps): EventItemMapProps => {
    const selectorProps: EntityRef = { id: props.parentId, source: props.source };
    const overlay = overlaySelector(state, selectorProps);
    const event = state.events.items.find((p) => p.id === props.id)!;

    return {
      ...props,
      imageStyle: imageStyleSelector(state, selectorProps),
      noImageUrl: getNoImageUrl(),
      event,
      dateStyle: dateStyleSelector(state, selectorProps),
      locationStyle: locationStyleSelector(state, selectorProps),
      nameStyle: nameStyleSelector(state, selectorProps),
      showOverlay: !!overlay,
      overlayColor: overlay?.color
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: EventItemContainerProps): EventItemActionProps => ({
  onClick: () => dispatch(chooseEvent(props.id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
